/**
 * Formats a file size in bytes to a human-readable string.
 * @param bytes The file size in bytes.
 * @returns The formatted file size.
 */
export function formatFileSize(bytes: number, fractionDigits: number = 1): string {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let index = 0;

  while (bytes >= 1024 && index < units.length - 1) {
    bytes /= 1024;
    index++;
  }

  return `${bytes.toFixed(fractionDigits)} ${units[index]}`;
}

export function shortenFileName(name: string, maxLength = 20) {
  if (name.length <= maxLength) return name;
  const extension = name.split(".").pop();

  return `${name.slice(0, maxLength - (extension?.length ?? 0) - 1)}...${extension}`;
}
